import React from "react";
import useStyles from "./ProductItem.style";

interface ProductItemProps {
    img: any;
    title: string;
    link: string;
    description: string;
}

const ProductItem = (props: ProductItemProps) => {
    const { img, title, description, link } = props;
    const classes = useStyles();

    const openInNewTab = () => {
        const newWindow = window.open(link, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };
    return (
        <div className={classes.productItem_container} onClick={() => openInNewTab()}>
            <div className={classes.leftSide}>
                <img className={classes.productImage} src={img} alt={title} title={title} />
            </div>
            <div className={classes.rightSide}>
                <div className={classes.productTitle}>{title}</div>
                <p className={classes.productDescription}>{description}</p>
            </div>
        </div>
    );
};

export default ProductItem;
